import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const PoweredBy = ({ isDark }) => (
  <div className="flex shrink-0 items-center justify-center gap-1 pb-12 xs:hidden">
    <span className={cn('text-xs', isDark ? 'text-neutral-dark-300' : 'text-neutral-600')}>
      Powered by
    </span>
    <Icon icon={isDark ? 'logo-white' : 'logo'} size={73} />
  </div>
);

export default PoweredBy;
